<template>
    <div class="xl:w-[1300px] w-[900px]">
        <div class="font-Montserrat font-bold text-5xl text-center mb-[50px] ">{{ $t('Discover-More-Al-Tools') }}</div>
        <div class="Roboto-Bold-24 mt-8 flex justify-center">
            <div class="grid gap-5 mt-6 text-center text-base 
              grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                <div class="group hover:scale-105" v-for="(item, index) in toolList" :key="index">
                    <NuxtLink :to="localePath(item.to)">
                        <div
                            class="bg-mainColor-white5 w-fit rounded-3xl h-[240px] relative clip-container p-2 hover:border-indigo-500 group-hover:border-2">
                            <img :src="item.src" class="rounded-2xl object-cover h-[165px]" />
                            <div class="w-full my-5 mx-2 flex items-center justify-left Roboto-Bold-18 text-left">
                                <img class="h-6 w-6 mr-1" :src="item.icon" alt="" />
                                {{ item.content }}
                            </div>
                        </div>
                    </NuxtLink>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
const { t } = useI18n();
const localePath = useLocalePath();
const props = defineProps({
    funcType: {
        type: String,
        default: "enhance_pro",
    },
});

const toolList = ref([
    { to: { params: { funcType: 'ai_background_generator' }, name: 'picma_web-funcType' }, src: "/assets/images/index/home/AI_Background_Generator.webp", icon: "/assets/images/enhance/icons/AI_Background_Generator-2.svg", content: t("ai_background_generator") },
    { to: { params: { funcType: 'ai_art_generator' }, name: 'picma_web-enhance-funcType' }, src: "/assets/images/index/home/AI_Art_Generator.webp", icon: "/assets/images/enhance/icons/AI_Art_Generator-2.svg", content: t("ai_art_generator") },
    { to: { params: { funcType: 'face_cutout' }, name: 'picma_web-funcType' }, src: "/assets/images/index/home/Face_Cutout.webp", icon: "/assets/images/enhance/icons/Face Cutout-2.svg", content: t("face_cutout") },
    { to: { params: { funcType: 'ai_e_commerce' }, name: 'picma_web-funcType' }, src: "/assets/images/index/home/AI_E_Commerce.webp", icon: "/assets/images/enhance/icons/AI E-Commerce-2.svg", content: t("ai_e_commerce") },
])

</script>